import { get } from '../utils/httpClient'
import { getRedDataConfig } from '../config'

export type BrazeAppType = 'android' | 'ios' | 'web'

export const apiGetBrazeToken = async (appType: BrazeAppType) => {
  const { accessToken }: { accessToken: string } = await get(`${getRedDataConfig().brazeJwtUrl}?app=${appType}`, true)
  return accessToken
}
